import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { FilterProvider } from "../../context/FilterContext";

export default function AppLayout() {
  return (
    <FilterProvider>
      <div className="flex bg-background min-h-screen">
        <Sidebar />
        <div className="flex-1 min-w-0 flex flex-col">
          <Topbar />
          <main className="flex-1 p-6 lg:p-8 max-w-[1600px] w-full">
            <Outlet />
          </main>
        </div>
      </div>
    </FilterProvider>
  );
}
